import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Divider, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";
import { PermissionActionsEnum, PermissionRolesEnum } from "../../../../shared/enums/profiles";
import { checkByProfileGuard } from "../../../../shared/guards/ProfileGuard";
import { IListInvoice } from "../../../../shared/services/api/financial/FinancialService";

export type BlockInvoiceMenuAction = "details" | "notifyClient" | "blockClient";

interface BlockInvoiceMenuProps {
	anchorEl: null | HTMLElement;
	open: boolean;
	onClose: () => void;
	selectedRow: IListInvoice | null;
	onOpenAction: (action: BlockInvoiceMenuAction, row: IListInvoice) => void;
}

export const BlockInvoiceMenu = ({ anchorEl, open, onClose, selectedRow, onOpenAction }: BlockInvoiceMenuProps) => {
	if (!selectedRow) return null;

	const canView = checkByProfileGuard(PermissionRolesEnum.FinancialOptions, PermissionActionsEnum.BlockMenuView);
	const canNotify = checkByProfileGuard(PermissionRolesEnum.FinancialOptions, PermissionActionsEnum.BlockNotify);
	const canBlock = checkByProfileGuard(PermissionRolesEnum.FinancialOptions, PermissionActionsEnum.BlockClient);
	const canBlockClient = selectedRow.client?.status !== "blocked";

	const handleAction = (action: BlockInvoiceMenuAction) => {
		onClose();
		onOpenAction(action, selectedRow);
	};

	return (
		<Menu anchorEl={anchorEl} open={open} onClose={onClose}>
			{canView && (
				<MenuItem onClick={() => handleAction("details")}>
					<ListItemIcon>
						<VisibilityIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText primary="Visualizar detalhes" />
				</MenuItem>
			)}

			{canView && canNotify && <Divider />}

			{canNotify && (
				<MenuItem onClick={() => handleAction("notifyClient")}>
					<ListItemIcon>
						<EmailOutlinedIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText primary="Notificar cliente" />
				</MenuItem>
			)}

			{canNotify && canBlock && <Divider />}

			{canBlock && (
				<MenuItem onClick={() => handleAction("blockClient")} disabled={!canBlockClient}>
					<ListItemIcon>
						<BlockOutlinedIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText primary="Bloquear imobiliária" />
				</MenuItem>
			)}
		</Menu>
	);
};